import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { Store } from '@ngrx/store';
import { FeatureFlag } from '../store/cms/models/feature-flag';
import { AppConfigService } from './app-config.service';
import { TransferStateService } from './transfer-state.service';

/**
 * Base App Init Service for shared initialization logic.
 * Extend this class in feature apps for domain-specific setup.
 */
@Injectable({
    providedIn: 'root',
})
export class AppInitService {
    appConfig = this.appConfigService$.config;

    constructor(
        protected readonly appConfigService$: AppConfigService,
        protected readonly router: Router,
        protected readonly activatedRoute: ActivatedRoute,
        protected readonly platformLocation: PlatformLocation,
        protected readonly store$: Store,
        protected readonly transferStateService: TransferStateService,
        @Inject(PLATFORM_ID) protected readonly platformId: Object,
    ) {}

    async appInit() {
        await this.appConfigService$.loadAppConfig();
    }

    /**
     * This enables us to use the base route setup in squidex to configure the base-route of the application
     * NOTE: Each brand has brand specific override
     * @param baseRoutes
     * @param featureFlags
     * @private
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public setupRoutes(baseRoutes: Array<string>, featureFlags: FeatureFlag) {
        if (baseRoutes) {
            const routes: Routes = [];
            this.router.resetConfig(routes);
        }
    }
}
